import { buildersApi } from "@/apis/api";
import { API_ENDPOINTS } from "@/constants/endpoints";

export interface GetBuilderDetailPayload {
  builderId?: string;
  mode?: "view" | "edit" | "view-mobile";
}

export interface SaveBuilderDetailPayload {
  builderId?: string;
  builderProfile: Record<string, unknown>;
}

export interface AddAuthorizedSignatoryPayload {
  builderId: string;
  authorizedSignatoryInfo: Record<string, unknown>;
}

export interface BuilderAccountStatus {
  username: string;
  kycUploadStatus: boolean;
  authorizedSignatoryStatus: boolean;
}

export const getBuilderDetailApi = async (
  payload: GetBuilderDetailPayload = {}
): Promise<any> => {
  const res = await buildersApi.post(API_ENDPOINTS.BUILDER.DETAILS, payload);
  return res.data;
};

export const saveBuilderDetailApi = async (
  payload: SaveBuilderDetailPayload
): Promise<any> => {
  const res = await buildersApi.post(API_ENDPOINTS.BUILDER.SAVE, payload);
  return res.data;
};

export const getAuthorizedSignatoryApi = async (): Promise<any> => {
  const res = await buildersApi.post(
    API_ENDPOINTS.BUILDER.GET_AUTHORIZED_SIGNATORY,
    {}
  );
  return res.data;
};

export const addAuthorizedSignatoryApi = async (
  payload: AddAuthorizedSignatoryPayload
): Promise<any> => {
  const res = await buildersApi.post(
    API_ENDPOINTS.BUILDER.ADD_AUTHORIZED_SIGNATORY,
    payload
  );
  return res.data;
};

export const getBuilderAccountStatusApi = async (): Promise<any> => {
  const res = await buildersApi.post(API_ENDPOINTS.BUILDER.ACCOUNT_STATUS, {});
  return res.data;
};
